import { BaseText, EBaseTextSize, EBaseTextWeight } from '@spinwise/react-component-library/BaseText';
import styles from './StepItem.module.scss';
import { EBrandTextColor } from 'Libraries/typography.library';
import Link from 'Components/shared/Link/Link';
import { PATHS } from 'Libraries/routes.library';
import { useRegType } from 'Hooks/useRegType';
import { useDispatch } from 'react-redux';
import {
  OVERLAY_PAYNPLAY_LOGIN_SHOW,
  OVERLAY_PAYNPLAY_REGISTER_SHOW,
  OVERLAY_PROMOTION_SHOW,
} from '@spinwise/spinwise-core';
import { EOverlayContentWidth, POSITIONS } from 'Components/shared/Overlay/elements/OverlayFixedBg/types';
import { basicChannel } from 'src/channels/basic.channel';
import { RegTypes } from 'Types/globals';
import { EBasicOverlays } from 'Components/shared/Overlay/elements/BasicOverlayManager/types';
import useShowAuthButtons from 'Hooks/useShowAuthButtons';

export interface IStepItem {
  header_title: string;
  title: string;
  subtitle: string;
  description: string;
  icon: any;
  index: number;
  currentIndex: number;
  btn_text: string;
  btn_url: string;
  bonus_terms_text: string;
  bonus_terms_link: string;
  availability_text: string;
  css: string;
  info_page: any;
}

const StepItem = (props: IStepItem) => {
  const isRegType = useRegType();
  const dispatch = useDispatch();

  const showAuthButtons = useShowAuthButtons();

  const hidePromoOverlay = () => {
    dispatch({
      type: OVERLAY_PROMOTION_SHOW,
      content: {
        show: false,
      },
    });
  };

  const generateButton = el => {
    if (isRegType([RegTypes.PAYPLAY_T, RegTypes.PAYPLAY_Z])) {
      switch (el.btn_url) {
        case PATHS.REGISTER:
          if (!showAuthButtons) return null;
          return (
            <div
              className={styles.item_cta}
              onClick={() => {
                hidePromoOverlay();
                dispatch({
                  type: OVERLAY_PAYNPLAY_REGISTER_SHOW,
                  data: {
                    show: true,
                  },
                });
              }}
            >
              {props?.btn_text}
            </div>
          );

        case PATHS.LOGIN:
          if (!showAuthButtons) return null;
          return (
            <div
              className={styles.item_cta}
              onClick={() => {
                hidePromoOverlay();
                dispatch({
                  type: OVERLAY_PAYNPLAY_LOGIN_SHOW,
                  data: true, // TODO: refactor to  { show: true } for persitency
                });
              }}
            >
              {props?.btn_text}
            </div>
          );
      }
    }
    // for email and deposit, simply return link with url
    
    return (
      <Link
        href={props?.btn_url}
        className={styles.item_cta}
        onClick={() => {
          hidePromoOverlay();
        }}
      >
        {props?.btn_text}
      </Link>
    );
  };

  const openTerms = (title, info_page) => {
    basicChannel.send({
      action: 'display',
      data: {
        content: {
          type: EBasicOverlays.InfoPage,
          overlayTitle: title,
          info_page: info_page,
        },
        position: POSITIONS.TOP,
        contentWidth: EOverlayContentWidth.LARGE,
      },
    });
  };

  return (
    <>
      <div className={`${styles.item_block} `}>
        <div className={styles.item_block__title}>
          {props?.title}
          <br></br>
          {props?.subtitle}
        </div>
        <div className={styles.item_block__image}>
          <img
            id="stepItemImg"
            src={props?.icon?.data?.attributes?.url}
            alt=""
            style={{
              width: '168px',
              height: '168px',
              objectFit: 'cover',
              position: 'absolute',
              right: '50%',
              transform: 'translate(50%, -2.5rem)',
            }}
          />
        </div>
        <div className={styles.item_block__description}>{props?.description}</div>
        {showAuthButtons ?
          <div className={styles.item_block__btn}>{generateButton(props)}</div>
        : null}
        <div className={styles.item_block__bonus_link}>
          {props.info_page !== null && props.bonus_terms_text !== null && (
            <div
              className={styles.item_block__bonus_link_container}
              onClick={() => {
                openTerms(props.bonus_terms_text, props.info_page);
              }}
            >
              <BaseText
                value={props?.bonus_terms_text}
                size={EBaseTextSize.Regular}
                weight={EBaseTextWeight.W400}
                color={EBrandTextColor.DarkViolet}
              />
            </div>
          )}
        </div>
        {props.availability_text && (
          <div className={styles.item_block__bonus_availability}>
            <BaseText
              value={props?.availability_text}
              size={EBaseTextSize.Regular}
              weight={EBaseTextWeight.W400}
              color={EBrandTextColor.Black04}
            />
          </div>
        )}
      </div>
    </>
  );
};
export default StepItem;
